var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConferenceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.333c0-.369.298-.667.667-.667h10.666c.368 0 .667.298.667.667v9.333a.667.667 0 01-.667.667H2.667A.667.667 0 012 12.666V3.333z",
    stroke: "#8DD6BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.998 1.332v2.667M10.998 1.332v2.667",
    stroke: "#8DD6BC",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.666 6.998H2.333",
    stroke: "#8DD6BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/conference-icon.3edb9c0c.svg";
export { SvgConferenceIcon as ReactComponent };